import { render, staticRenderFns } from "./familiar-ui-header.vue?vue&type=template&id=725703e2&scoped=true"
import script from "./familiar-ui-header.ts?vue&type=script&lang=ts&external"
export * from "./familiar-ui-header.ts?vue&type=script&lang=ts&external"
import style0 from "./familiar-ui-header.vue?vue&type=style&index=0&id=725703e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725703e2",
  null
  
)

export default component.exports